import { useQuery } from "@tanstack/react-query";
import { BACKEND_URL } from "../config";
import axios from "axios";

const getDomains = (search: string, url: string) => {
    return axios.request({
        url: `${url}/${search}`,
        method: "GET",
    });
};

export const useGetDomains = (search: string, enabled: boolean) => {
    const url = `${BACKEND_URL}/api/v1/domain-check`;

    return useQuery({
        queryKey: [url, search],
        queryFn: () => getDomains(search + ".de", url),
        refetchInterval: Infinity,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        enabled: enabled && search !== "" && search.length > 2,
    });
};
